/* jshint esnext: true */
import { APP_NAME, $document } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'ContactToggle';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export const EVENT = {
    CHANGE: `change.${EVENT_NAMESPACE}`,
    UPDATE: `update.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);
    }

    init() {
        this.$el.on(EVENT.CHANGE, '.js-contact-toggle', (event) => this.toggleContact(event));

        $document.on(EVENT.UPDATE, (event) => {
            event.scope.find('.js-contact-toggle').trigger(EVENT.CHANGE);
        });
    }

    toggleContact(event) {
        let $select = $(event.currentTarget);
        let $input = this.$el.find('.js-contact-toggle-target');
        let $panel = this.$el.find('.js-contact-toggle-panel');

        if ($select.prop('checked') === true) {
            $input.val(null);
            $input.attr('disabled', true);
            $panel.slideUp();
        } else {
            $input.attr('disabled', false);
            $panel.slideDown();
        }
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
